import r from "./restArguments.js";
import t from "./_flatten.js";
import o from "./filter.js";
import e from "./contains.js";
var f = r(function (r, f) {
  return f = t(f, !0, !0), o(r, function (r) {
    return !e(f, r);
  });
});
export { f as default };